import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { HorizontalListData } from 'common';
import { readWrite } from '../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { AccountStateWidgetData, AccountData } from '../account.model';
import { AccountService } from '../account.service';
import { getBarChartData, getBarChartOptions } from './account-state-widget-bar-chart-data';
import { AccountStateWidgetAdapter } from './account-state-widget.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-account-state-widget',
    templateUrl: './account-state-widget.component.html',
    styleUrls: ['./account-state-widget.component.scss'],
    providers: [AccountStateWidgetAdapter],
    standalone: false
})
export class AccountStateWidgetComponent implements OnInit, OnChanges {
  @Input() accountState: AccountStateWidgetData;
  @Input() account: AccountData;
  @Input() label: string;
  @Input() edit: boolean;

  barChartData: ChartConfiguration<"bar">["data"] = null;
  barChartOptions: ChartConfiguration<"bar">["options"] = null;

  accessNPLEconomics: boolean;
  listItems: HorizontalListData[];

  constructor(
    private readonly accountService: AccountService, 
    private readonly userPermissionService: UserPermissionService,
    private readonly adapter: AccountStateWidgetAdapter
  ) { }

  ngOnInit(): void {
    this.userPermissionService.granted([readWrite('servicing-account-npl-economics')])
      .pipe(untilDestroyed(this))  
      .subscribe(res => this.accessNPLEconomics = res);
  }

  ngOnChanges(): void {
    this.initChart();
    this.listItems = this.adapter.adaptListData(this.accountState, this.account);
  }

  private initChart(): void {
    this.barChartData = getBarChartData([this.accountState?.utilization], [this.label]);
    this.barChartOptions = getBarChartOptions;
  }

  getOutstandingBalance(): number {
    return this.accountService.getOutstandingBalance(this.account);
  }

  isNPLLoan(): boolean{
    return this.accountService.isNPLLoan(this.account?.status);
  }
}
